import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录'
      },
      component: () => import('../views/login.vue')
    },
    {
      path: '/fulinLife',
      name: 'fulinLife',
      meta: {
        title: '富邻生活频道页'
      },
      component: () => import('../views/fulin/index.vue')
    },
    {
      path: '/fulinHousekeeping',
      name: 'fulinHousekeeping',
      meta: {
        title: '富邻家政频道页'
      },
      component: () => import('../views/fulin/housekeeping.vue')
    },
    {
      path: '/fulinGroup',
      name: 'fulinGroup',
      meta: {
        title: '富邻团购频道页'
      },
      component: () => import('../views/fulin/index.vue')
    },
    {
      path: '/fulinRankDetail',
      name: 'fulinRankDetail',
      component: () => import('../views/fulin/rank.vue')
    },
    {
      path: '/rfFair',
      name: 'rfFair',
      meta: {
        title: '小富市集',
        keepAlive: true
      },
      component: () => import('../views/activity/rfFair.vue')
    },
    {
      path: '/market/:id',
      name: 'market',
      meta: {
        title: '生活超市'
      },
      component: () => import('../views/market.vue')
    },
    {
      path: '/market',
      name: 'marketAppUse',
      meta: {
        title: '生活超市'
      },
      component: () => import('../views/market.vue')
    },
    {
      path: '/search',
      name: 'search',
      meta: {
        title: '搜索'
      },
      component: () => import('../views/search.vue')
    },
    {
      path: '/allShopCart',
      name: 'allShopCart',
      meta: {
        title: '购物车'
      },
      component: () => import('../views/allShopCart.vue')
    },
    // {
    //   path: '/allShopCart/:id/:accessToken',
    //   name: 'allShopCartAppUse',
    //   meta: {
    //     title: '购物车'
    //   },
    //   component: () => import('../views/allShopCart.vue')
    // },
    {
      path: '/goodsDetail',
      name: 'goodsDetail',
      meta: {
        title: '商品详情'
      },
      component: () => import('../views/goodsDetail.vue')
    },
    {
      path: '/evaluateList',
      name: 'evaluateList',
      meta: {
        title: '评价列表'
      },
      component: () => import('../views/evaluateList.vue')
    },
    {
      path: '/evaluateForm/:orderId',
      name: 'evaluateForm',
      meta: {
        title: '商品评价'
      },
      component: () => import('../views/evaluateForm.vue')
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        title: '商城'
      },
      component: () => import('../views/home/tabContainerHome.vue')
    },
    {
      path: '/homeinfo',
      name: 'home_INFO',
      meta: {
        title: '周边商家模板'
      },
      component: () => import('../views/homeInfo.vue')
    },
    {
      path: '/discountDetail/:id',
      name: 'discountDetail',
      meta: {
        title: '周边商家模板'
      },
      component: () => import('../views/discountDetail.vue')
    },
    {
      path: '/error',
      name: 'error',
      meta: {
        title: '出错了:('
      },
      component: () => import('../views/error.vue')
    },
    {
      path: '/confirmOrder/:isInstantBuy/:goodId',
      name: 'confirmOrderAppUse',
      meta: {
        title: '订单确认'
      },
      component: () => import('../views/confirmOrder.vue')
    },
    {
      path: '/confirmOrder',
      name: 'confirmOrder',
      meta: {
        title: '订单确认'
      },
      component: () => import('../views/confirmOrder.vue')
    },
    {
      path: '/confirmPay',
      name: 'confirmPay',
      meta: {
        title: '正在支付'
      },
      component: () => import('../views/confirmPay.vue')
    },
    {
      path: '/quickPay',
      name: 'quickPay',
      meta: {
        title: '闪付确认'
      },
      component: () => import('../views/quickPay.vue')
    },
    {
      path: '/personalCenter',
      name: 'personalCenter',
      meta: {
        title: '个人中心'
      },
      component: () => import('../views/personalCenter.vue')
    },
    {
      path: '/cityList',
      name: 'cityList',
      meta: {
        title: '城市列表'
      },
      component: () => import('../views/cityCommunitySelect/cityList.vue')
    },
    {
      path: '/communityList',
      name: 'communityList',
      meta: {
        title: '社区列表'
      },
      component: () => import('../views/cityCommunitySelect/communityList.vue')
    },
    // {
    //   path: '/personalCenter/*',
    //   // redirect: '/personalCenter'
    //   name: 'personalCenterAppUse',
    //   meta: {
    //     title: '个人中心'
    //   },
    //   component: () => import('../views/personalCenter.vue')
    // },
    {
      path: '/rfActivity',
      name: 'rfActivity',
      meta: {
        title: '活动'
      },
      component: () => import('../views/activity/rfActivity.vue')
    },
    {
      path: '/rfStation',
      name: 'rfStation',
      meta: {
        title: '社区小站'
      },
      component: () => import('../views/activity/rfStation.vue')
    },
    {
      path: '/toolRental',
      name: 'toolRental',
      meta: {
        title: '工具租借'
      },
      component: () => import('../views/activity/toolRental.vue')
    },
    // {
    //   path: '/paySuccess/:orderId/:orderMoney',
    //   name: 'paySuccess2',
    //   meta: {
    //     title: '支付成功'
    //   },
    //   component: () => import('../views/paySuccess.vue')
    // },
    {
      path: '/payForMe',
      name: 'payForMe',
      component: () => import('../views/payForMe.vue')
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      meta: {
        title: '支付成功'
      },
      component: () => import('../views/paySuccess.vue')
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      meta: {
        title: '订单详情'
      },
      component: () => import('../views/orderDetail.vue')
    },
    {
      path: '/downloadapp',
      name: 'downloadApp',
      meta: {
        title: '下载app'
      },
      component: () => import('../views/downloadApp.vue')
    },
    {
      path: '/orderQRCodeDetail/:orderId',
      name: 'orderQRCodeDetail',
      meta: {
        title: ''
      },
      component: () => import('../views/orderQRCodeDetail.vue')
    },
    {
      path: '/orderQRCodeDetail-allinpay/:orderId',
      name: 'orderQRCodeDetail-allinpay',
      meta: {
        title: ''
      },
      component: () => import('../views/orderQRCodeDetail-allinpay.vue')
    },
    {
      path: '/pickCoupon',
      name: 'pickCoupon',
      meta: {
        title: '选择优惠券'
      },
      component: () => import('../views/pickCoupon.vue')
    },
    {
      path: '/pickCouponQuick',
      name: 'pickCouponQuick',
      meta: {
        title: '选择优惠券'
      },
      component: () => import('../views/pickCouponQuick.vue')
    },
    {
      path: '/quickOrderDetail',
      name: 'quickOrderDetail',
      meta: {
        title: '闪付订单'
      },
      component: () => import('../views/quickOrderDetail.vue')
    },
    {
      path: '/editAddress',
      name: 'editAddress',
      meta: {
        title: '地址编辑或新增'
      },
      component: () => import('../views/address/editAddress.vue')
    },
    {
      path: '/receiptAddress',
      name: 'receiptAddress',
      meta: {
        title: '收货地址'
      },
      component: () => import('../views/address/receiptAddress.vue')
    },
    {
      path: '/afterSales',
      name: 'afterSales',
      meta: {
        title: '申请售后'
      },
      component: () => import('../views/afterSales.vue')
    },
    {
      path: '/refundDetail',
      name: 'refundDetail',
      meta: {
        title: '退款详情'
      },
      component: () => import('../views/refundDetail.vue')
    },
    {
      path: '/optimizingDetail',
      name: 'optimizingDetail',
      meta: {
        title: '优选订单详情'
      },
      component: () => import('../views/optimizingDetail.vue')
    },
    // {
    //   path: '/homeSearch',
    //   name: 'homeSearch',
    //   meta: {
    //     title: '搜索'
    //   },
    //   component: () => import('../views/home/homeSearch.vue')
    // },
    {
      path: '/groupList',
      name: 'groupList',
      meta: {
        title: '正在拼团'
      },
      component: () => import('../views/group/groupList.vue')
    },
    {
      path: '/groupDetail',
      name: 'groupDetail',
      meta: {
        title: '团购详情'
      },
      component: () => import('../views/group/groupDetail.vue')
    },
    {
      path: '/centerListCoupon',
      name: 'centerListCoupon',
      meta: {
        title: '购券中心'
      },
      component: () => import('../views/coupon/CenterListCoupon.vue')
    },
    {
      path: '/applyShopList',
      name: 'applyShopList',
      meta: {
        title: '适用的店铺'
      },
      component: () => import('../views/coupon/ApplyShopList.vue')
    },
    {
      path: '/confirmOrderCoupon',
      name: 'confirmOrderCoupon',
      meta: {
        title: '购券确认购买'
      },
      component: () => import('../views/coupon/ConfirmOrderCoupon.vue')
    },
    {
      path: '/orderDetailCoupon',
      name: 'orderDetailCoupon',
      meta: {
        title: '抵用券订单详情'
      },
      component: () => import('../views/coupon/OrderDetailCoupon.vue')
    },
    {
      path: '/paySuccessCoupon',
      name: 'paySuccessCoupon',
      meta: {
        title: '购券成功'
      },
      component: () => import('../views/coupon/PaySuccessCoupon.vue')
    },
    {
      path: '/personalOrderListCoupon',
      name: 'personalOrderListCoupon',
      meta: {
        title: '我的抵用券'
      },
      component: () => import('../views/coupon/PersonalOrderListCoupon.vue')
    },
    {
      path: '/purchaseDetailCoupon',
      name: 'purchaseDetailCoupon',
      meta: {
        title: '购券详情'
      },
      component: () => import('../views/coupon/PurchaseDetailCoupon.vue')
    },
    {
      path: '/offlinePayment',
      name: 'offlinePayment',
      meta: {
        title: '企业采购'
      },
      component: () => import('../views/offlinePayment.vue')
    },

    /* 用于社区运营者推广的店铺、商品详情页 */
    {
      path: '/storeDetailPromo',
      name: 'storeDetailPromo',
      meta: {
        title: '店铺详情'
      },
      component: () => import('../views/promo/storeDetailPromo.vue')
    },
    {
      path: '/goodsDetailPromo',
      name: 'goodsDetailPromo',
      meta: {
        title: '商品详情'
      },
      component: () => import('../views/promo/goodsDetailPromo.vue')
    },
    {
      path: '/transferPage',
      name: 'transferPage',
      meta: {
        title: '绑定钱包'
      },
      component: () => import('../views/transferPage.vue')
    },
    {
      path: '/tmallTransferPage',
      name: 'tmallTransferPage',
      meta: {
        title: '天猫超市卡活动'
      },
      component: () => import('../views/tmallTransferPage.vue')
    },
    { path: '*',
      redirect: '/search' }
  ]
})

export default router
